import styled from "styled-components"
import { 
  COLOR,
  FONT_SIZE,
  Z_INDEXS
} from "../../../themes"
import { colorThemeSelector } from "../../../helpers"

export const Style = styled.div`
  position: relative;
  * {
    margin: 0px;
    padding: 0px;
  }

  .multi-input {
    border: none;
    outline: none;
    line-height: 1.5;
    font-family: NunitoRegular;
    font-size: 18px;
    font-weight: 400;
    padding: 0;
    margin: 0;
    color: ${COLOR.BLACK_6};
    background: transparent;
    flex: 1;
    min-width: 50px;
  }

  .multi-input::placeholder {
    padding: 3px 0;
  }

  .multi-area {
    border: 1px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    background-color: transparent;
    box-shadow: none;
    color: ${COLOR.BLACK_6};
    box-sizing: border-box;
    display: flex;
    align-items: center;
    min-height: 48px;
    padding: 12px 16px;
    width: 100%;
  }

  .multi-area input {
    align-self: center;
  }

  .icon-cancel,
  .icon-cancel-dropdown {
    width: 24px;
    height: 24px;
    vertical-align: middle;
    cursor: pointer;
    margin-right: 0px;
  }


  .multi-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    list-style-type: none;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
  }

  .multi-container .multi-box {
    border-radius: 5px;
    margin: 1px;
    padding: 5px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: 10px;
    margin-left: 5px;
    color: #000;
    background-color: #f1f2f2;
  }

  .multi-box .close {
    background-color: #000000;
    color: #ffffff;
    width: 18px;
    height: 18px;
    display: -webkit-box;
    border-radius: 20px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-left: 5px;
    font-size: 10px;
    cursor: pointer;
  }

  .multi-result {
    width: 100%;
    max-height: 200px;
    border: 1px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    background-color: #FFFFFF;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 10;
    overflow-y: auto;
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
  }

  .result-searching {
    padding: 12px 16px;
    font-family: NunitoRegular, NunitoSans, sans-serif;
    font-size: 14px;
    color: ${COLOR.GRAY_27};
  }

  .result-list {
    line-height: 24px;
    height: 68px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
  }

  .result-list:hover {
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    cursor: pointer;
  }

  .result-list:hover .result-title {
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT};
  }

  .result-list:hover .result-description {
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.SUB_TEXT};
  }

  .result-list figure {
    height: 44px;
    width: 44px;
    margin: 12px 16px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #E6E6F6;
  }
  
  .result-avatar-img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    color: #E6E6F6;
    fill: #E6E6F6;
    border-radius: 80px;
  }

  .result-group {
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    flex: 1;
    height: auto;
  }

  .result-title {
    margin: 0;
    padding: 0;
    line-height: 24px;
    font-family: NunitoMedium, NunitoSans, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: ${COLOR.BLACK_6};
  }

  .result-description {
    margin: 0;
    padding: 0;
    line-height: 20px;
    font-family: NunitoRegular, NunitoSans, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: ${COLOR.GRAY_27};
  }

  .multi-select-list {
    width: 100%;
    max-height: 280px;
    overflow-x: scroll;
  }

  .select-list {
    line-height: 24px;
    height: 68px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    display: flex;
    align-items: center;
    flex-direction: row;
  }

  .select-list figure {
    height: 44px;
    width: 44px;
    margin: 12px 16px 12px 0px;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #E6E6F6;
  }

  button.close-button {
    margin: auto 0;
    padding: 0;
    width: 16px;
    height: 16px;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
    margin-right: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  button.close-button > * {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  .disabled,
  .disabled * {
    background-color: ${COLOR.GRAY_2} !important;
    cursor: not-allowed !important;
    pointer-events: none;
  }
`




